import { render, staticRenderFns } from "./solventAdd.vue?vue&type=template&id=663b374c&"
import script from "./solventAdd.vue?vue&type=script&lang=js&"
export * from "./solventAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('663b374c')) {
      api.createRecord('663b374c', component.options)
    } else {
      api.reload('663b374c', component.options)
    }
    module.hot.accept("./solventAdd.vue?vue&type=template&id=663b374c&", function () {
      api.rerender('663b374c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/data-dictionary/solvent/solventAdd.vue"
export default component.exports